import { render, staticRenderFns } from "./botSet.vue?vue&type=template&id=ab67e7f4&"
import script from "./botSet.vue?vue&type=script&lang=js&"
export * from "./botSet.vue?vue&type=script&lang=js&"
import style0 from "./botSet.vue?vue&type=style&index=0&id=ab67e7f4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports